import ParentDashboardComponent from '../components/dashboard/parent';

export default function ParentDashboard() {
  return <ParentDashboardComponent />;
}
